/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AssignTaskCreate = lazyLoad(
  () => import('./index'),
  module => module.AssignTaskCreate
);
